import React from "react";
import Panel from "../../Panel/Panel";
import BookingAdditionalInformation from "../additional_information/BookingAdditionalInformation";

export default class BookingAdditionalInformationSection extends React.Component {

	constructor(props) {
		super(props);

    this.state = {
      errors: null,
      success: null,
    	loading: false,
      forgot_password_visible: false,
      resend_confirmation_visible: false,
 
    };
    this.onAdditionalInformationSuccess = this.onAdditionalInformationSuccess.bind(this);
	};

	render() {
    return (
      <div className="AdditionalInformationSection" >
        <a id="AdditionalInformation" name="AdditionalInformation"></a>
   
        <Panel name="AdditionalInformation" 
               expanded={this.props.expanded}
               onExpandCollapse={this.props.guestSectionValid ? this.props.onExpandCollapse : null}
               header={this.renderHeader()}
               body={this.renderBody()}
               add_info_panel={true}
        />
      </div>
    );
	}

  renderBody() {
    if (this.props.expanded) {
      return (
        <div className="expand-collapse-body">
          {this.renderErrors()}
          <BookingAdditionalInformation {...this.props} onAdditionalInformationSuccess={this.onAdditionalInformationSuccess} errors={this.state.errors} />
          {this.renderContinueButton()}
        </div>
      );
    } 
  }

  renderContinueButton() {
    return (
      <div className="continue-btn-wrapper" style={{paddingTop:"10px"}}>
        <div className="continue-btn-wrapper"><button type="button" className="btn" onClick={(e) => { this.onValidateCustomerFormFieldAnswers(e)}} >{I18n.t('continue')}</button></div>
      </div>
    );
  }

  renderHeader() {
    return (
      <div>
        <span className={"step-number " + (this.props.customerFormFieldsValid ? 'complete' : '')}>{this.props.customerFormFieldsValid ? '✔' : 2}</span>
        <h3>{I18n.t('additional_information')}</h3>
        {
          this.props.expanded
  
        }
      </div>
    );
  }

  onAdditionalInformationSuccess() {
    this.props.onGoto('Payment')
  }

  onValidateCustomerFormFieldAnswers() {
    var self = this;
    self.setState({loading: true});
    $.ajax({
      type: 'POST',
      url: this.props.validate_customer_form_field_answers_path,
      data: {
        ...this.props.guest_information,
        account_id: this.props.account.id,
        property_id: this.props.property.id,
        property: this.props.property.id,
        api_key: this.props.account.api_key,
        answers: this.props.guest_information.answers || [],
        rating_answers: this.props.rating_answers || [],
        emoji_answers: this.props.emoji_answers || [],
      }
    }).done((data) => {
      if (data && data.errors) {
        self.setState({loading: false, errors: data.errors, success: null});
        self.props.onChangeCustomerFormFieldsValid(false)
      } else {
        if (typeof this.onAdditionalInformationSuccess === 'function') {
          setTimeout(self.props.onAdditionalInformationSuccess, 1);
          self.props.onChangeCustomerFormFieldsValid(true)
        }
        self.setState({loading: false, errors: null, success: null});
        this.props.onGoto('Payment');
      }
    });
  }

	renderErrors() {
		var self = this;
		if (this.hasErrors()) {
			if (Array.isArray(this.state.errors)) {
				var errors = this.state.errors.map(function (error) {
          return <li key={error} dangerouslySetInnerHTML={{__html: self.processError(error)}}></li>
	      });
			} else {
				var errors = Object.keys(this.state.errors).map(function (key) {
          if (I18n.lookup(key)) {
            var name = I18n.t(key)
          } else {
            var name = self.props.form_fields.filter((field) => { return key == field.id })[0].field
          }
	      	return <li key={key}>{name} {self.state.errors[key][0]}</li>
	      });
			}
      return (
        
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
		}
	}

  hasErrors() {
    return this.state.errors && ((Array.isArray(this.state.errors) && this.state.errors.length > 0) || Object.keys(this.state.errors).length > 0)
  }
  
  processError(error) {
    error = error.replace(/%{forgot_password_link}/gi, `<a href="#" class="link-delegate" data-action="forgot_password">${I18n.t('forgot_password').toLowerCase()}</a>`)
    error = error.replace(/%{sign_in_link}/gi, `<a href="#" class="link-delegate" data-action="sign_in">${I18n.t('sign_in').toLowerCase()}</a>`)
    return error
  }
};